export default {
  'BankNameTitle': 'Bank Name',
  'AccountNameTitle': 'Account Name',
  'BankAddressTitle': 'Bank Address',
  'SwiftTitle': 'SWIFT Code',
  'xzSecuritiesAccTitleHK': '[Securities] DBS Bank Account Number (HKD)',
  'zgSecuritiesAccTitleHK': '[Securities] China Bank Account Number (HKD)',
  'FPSSecuritiesAccTitleHK': '[Securities] Fast Transfer Number (FPS) Transfer Identification Code (HKD)',
  'xzFuturesAccTitleHK': '[Futures] DBS Bank Account Number (HKD)',
  'zgFuturesAccTitleHK': '[Futures] China Bank Account Number (HKD)',
  'FPSFuturesAccTitleHK': '[Futures] Transfer Fast Number (FPS) Transfer Identification Code (HKD)',
  'gsForexAccTitleHK': '[Foreign Exchange] ICBC Account Number (HKD)',
  'FPSForexAccTitleHK': '[Foreign Exchange] Fast (FPS) Transfer Identification Code (HKD)',
  'gsMFAccTitleHK': '[FX Pro] ICBC Account Number (HKD)',
  'gsPMAccTitleHK': '[Spot Gold] ICBC Account Number (HKD)',
  'xzSecuritiesAccTitleUS': '[Securities] DBS Bank Account Number (USD)',
  'zgSecuritiesAccTitleUS': '[Securities] China Bank Account Number (USD)',
  'xzFuturesAccTitleUS': '[Futures] DBS Bank Account Number (USD)',
  'zgFuturesAccTitleUS': '[Futures] Bank of China Account Number (USD)',
  'gsForexAccTitleUS': '[Foreign Exchange] ICBC Account Number (USD)',
  'gsMFAccTitleUS': '[FX Pro] ICBC Account Number (USD)',
  'gsPMAccTitleUS': '[Spot Gold] ICBC Account Number (USD)',
  'xzSecuritiesAccTitleCN': '[Securities] DBS Bank Account Number (CNY)',
  'zgSecuritiesAccTitleCN': '[Securities] Bank of China Account Number (CNY)',
  'xzFuturesAccTitleCN': '[Futures] DBS Bank Account Number (CNY)',
  'zgFuturesAccTitleCN': '[Futures] Bank of China Account Number (CNY)',
  'gsForexAccTitleCN': '[Foreign Exchange] ICBC Account Number (CNY)',
  'gsMFAccTitleCN': '[FX Pro] ICBC Account Number (CNY)',
  'gsPMAccTitleCN': '[Spot Gold] ICBC Account Number (CNY)',
  'xzSecuritiesAccHK': '016-478-783313006',
  'zgSecuritiesAccHK': '012-873-2-002063-5',
  'FPSSecuritiesAccHK': 7853658,
  'xzFuturesAccHK': '016-478-000324487',
  'zgFuturesAccHK': '012-873-2-002064-8',
  'FPSFuturesAccHK': 7025075,
  'gsForexAccHK': '072-722-502-013475',
  'FPSForexAccHK': 4009940,
  'xzSecuritiesAccUS': '016-478-000677626',
  'zgSecuritiesAccUS': '012-873-2-002065-1',
  'xzFuturesAccUS': '016-478-000677644',
  'zgFuturesAccUS': '012-873-2-002066-4',
  'gsForexAccUS': '072-722-506-002314',
  'xzSecuritiesAccCN': '016-478-000677635',
  'zgSecuritiesAccCN': '012-873-2-002067-7',
  'xzFuturesAccCN': '016-478-000677653',
  'zgFuturesAccCN': '012-873-2-002068-0',
  'gsForexAccCN': '072-722-560-002224',
  'xzBankName': 'DBS Bank (Hong Kong) Limited',
  'zgBankName': 'Bank of China (Hong Kong) Company Limited',
  'FPSName': 'Fast Transfer Number (FPS) Transfer Identification Code',
  'gsBankName': 'Industrial and Commercial Bank of China (Asia) Limited',
  'zgAccountName': 'Eddid Securities and Futures Limited',
  'xzAccountName': 'Eddid Securities and Futures Limited',
  'gsAccountName': 'Eddid Securities and Futures Limited',
  'zgBankAddress': 'Silver Tower Bank of China Tower, 1 Garden Road, Central, 1 Garden Road, Central, Hong Kong',
  'xzBankAddress': "11 / F, 11 F Central Centre, 99 Central Queen Avenue, Central, The Center, 99 Queen's Road, Central",
  'gsBankAddress': 'Garden Road, Central, 3 ICBC Building ICBC Tower, 3 Garden Road, Central, Hong Kong',
  'zgSwiftCode': 'BKCHHKHHXXX',
  'xzSwiftCode': 'DHBKHKHH',
  'gsSwiftCode': 'UBHKHKHH',
  'CurHK': 'HKD',
  'CurUS': 'USD',
  'CurCN': 'CNY',
  'payee': 'Name of Payee',
  'bankNum': 'Bank Card Number',
  'payeeNum': 'Recipient Account Number'
}
